import { render, staticRenderFns } from "./modal-contact-number.vue?vue&type=template&id=28a1abd8"
import script from "./modal-contact-number.vue?vue&type=script&lang=js"
export * from "./modal-contact-number.vue?vue&type=script&lang=js"
import style0 from "./modal-contact-number.vue?vue&type=style&index=0&id=28a1abd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports